import { useNavigate } from "react-router-dom";
import { relativeURL } from "../relativeURL";

export const useColorList = () => {
  let navigate = useNavigate();
  async function applyColor(payload) {
    // console.log(payload.position);
    const resp = await fetch(relativeURL("/api/color"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const body = await resp.json();
    if (body["valid"] === false) {
      alert(body["msg"]);
    } else {
      navigate(`/session/${body.sid}`);
    }
  }

  return {
    applyColor,
  };
};
